import { render, staticRenderFns } from "./VerifyStep5.vue?vue&type=template&id=37c1a6da&"
import script from "./VerifyStep5.vue?vue&type=script&lang=js&"
export * from "./VerifyStep5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports